import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, mergeMap, switchMap } from 'rxjs/operators';
import * as ReRouteActions from '../actions/re-route.actions';
import { ReRouteAPIService } from 'src/app/re-route/services/re-route.api.service';
import { AuthFactoryService } from 'src/app/auth/authFactory.service';
import { ReportLogService } from 'src/app/shared/services/report-log.service';
import { ActionTypeText } from 'src/app/core/enums/enums';

@Injectable()
export class ReRouteEffects {
  constructor(
    private authFactoryService: AuthFactoryService,
    private reRouteService: ReRouteAPIService,
    private reportLog: ReportLogService,
    private actions$: Actions
  ) {}

  forceRefreshSesionAndReRoute$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ReRouteActions.ForceRefreshSesionAndReRoute),
      mergeMap((action) =>
        this.authFactoryService.forceRefreshSession().pipe(
          map(() => {
            return ReRouteActions.reRouteQuoteRequest({
              reRouteQuoteRequest: action.reRouteQuoteRequest
            });
          }),
          catchError((response) => {
            window.scroll(0, 0);
            return of(
              ReRouteActions.reRouteQuoteRequestFail({
                error: response.error
              })
            );
          })
        )
      )
    )
  );

  ReRouteNoShowRequest$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ReRouteActions.reRouteQuoteRequest),
      switchMap((action) =>
        this.reRouteService.postReRouteNoShowRequest(action.reRouteQuoteRequest).pipe(
          map((pnr) => {
            this.reportLog.Success(ActionTypeText.Reschedule);
            return ReRouteActions.reRouteQuoteRequestSuccess({ pnr });
          }),
          catchError((response) => {
            this.reportLog.Failure(ActionTypeText.Reschedule, response.error);
            return of(
              ReRouteActions.reRouteQuoteRequestFail({
                error: response.error
              })
            );
          })
        )
      )
    )
  );
}
